import { AVAILABLE_BRAND_FEATURES } from '@kouto/types';
import { useAppState } from 'AppProvider';

export const isFeatureActive = (feature: AVAILABLE_BRAND_FEATURES) => {
  const { brand } = useAppState();
  const { settings } = brand || {};
  return settings?.features?.active.includes(feature) || false;
};
